import React from 'react';

import Currency from '../../Currency';
import Typography from '../../Typography';
import SpotlioIcon from '../../Icon';
import './index.scss';

const Cart = ({isOnTab,onTrigger,configuration,cart}) => {
    return(
        <div 
            onClick={onTrigger} 
            className={`${isOnTab?"cartBadgeNavbar":"cartBadge"} ${configuration.head && configuration.head.fullHeightBadge ? "fullHeightBadge" : ""}`}
        >
            <div className="cartIcon">
                <SpotlioIcon icon="sp2-shopping-cart" />
                {
                    !isOnTab &&
                    <div className="cartCounter">
                        <Typography className="h300bold">
                            {cart.badge}
                        </Typography>
                    </div>

                }
            </div>
                <div>
                    {isOnTab &&
                        <div>{`${cart.badge} item(s)`}</div>
                    }
                    <Currency ignoreSmallerFontSize={isOnTab} value={cart.total} noFree={true} />
                </div>
        </div>
    )
}

export default Cart;